import script from "./leftBar1.vue?vue&type=script&setup=true&lang=js"
export * from "./leftBar1.vue?vue&type=script&setup=true&lang=js"

export default script